module.exports = __webpack_public_path__ + "img/photo-14.f5bdb44c.jpg";